module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents-b/vantaggio_entry_fee.6adfd3ece34b104225186eb7e948bdc8.jpg";